export default "__VITE_ASSET__BNi5Tj0n__"